<template>
  <div class="chores-body" :key="choresListKey">
    <ChoreCell
      v-for="chore of this.filteredChores"
      :key="chore.uuid"
      :chore="chore"
      :readOnly="true"
    />

    <section class="empty-chores-screen" v-if="filteredChores.length === 0">
      <img src="../../assets/no_filtered_chores.svg" />
      <div class="no-result">No results found</div>
      <div>We couldn’t find the chore you are looking for</div>
    </section>
  </div>
</template>

<script>
import ChoreCell from '@/components/tasks/ChoreCell.vue'
import calls from '@/api/calls'
import { auth } from '../../Firebase'

export default {
  name: 'MyChoresScreen',
  components: {
    ChoreCell
  },
  data() {
    return {
      chores: [],
      properties: [],
      selTask: null,
      selPropperty: {},
      selAssignment: null,
      showMenu: false,
      showDeleteMenu: false,
      showEditAssignmentMenu: false,
      showAssignmentMenu: false,
      allHousemates: [],
      propertiesFilterSelected: false,
      choresFilterSelected: false,
      mouseCoordsProperties: null,
      mouseCoordsChores: null,
      selProperties: [],
      selChores: [],
      selChore: null, //the chore from the chore card that you are assigning
      referencedProperty: null, //the propertie from which this chore belongs to ^
      choresListKey: 0
    }
  },
  computed: {
    filteredChores() {
      const filtered = []
      const ids = []
      for (let chore of this.chores) {
        if (
          this.selProperties.length > 0 &&
          !this.selProperties.includes(chore.propertyUuid)
        )
          continue
        if (this.selChores.length > 0 && !this.selChores.includes(chore.uuid))
          continue
        if (ids.includes(chore.uuid)) continue
        filtered.push(chore)
        ids.push(chore.uuid)
      }
      return filtered
    },
    noChores() {
      return !this.chores.length > 0
    }
  },
  methods: {
    filterByProperties(id) {
      if (this.selProperties.includes(id)) {
        const index = this.selProperties.indexOf(id)
        this.selProperties.splice(index, 1)
      } else {
        this.selProperties.push(id)
      }
    },
    filterByChores(id) {
      if (this.selChores.includes(id)) {
        const index = this.selChores.indexOf(id)
        this.selChores.splice(index, 1)
      } else {
        this.selChores.push(id)
      }
    },
    styleFilterProperties() {
      return {
        left: this.mouseCoordsProperties.x + 'px',
        top: this.mouseCoordsProperties.y + 48 + 'px'
      }
    },
    styleFilterChores() {
      return {
        left: this.mouseCoordsChores.x - 120 + 'px', //this is the containers with + padding
        top: this.mouseCoordsChores.y + 48 + 'px' //magic value
      }
    },
    choresFilterClicked() {
      this.choresFilterSelected = !this.choresFilterSelected
      const el = this.$refs['task-cards-chore-filter']
      this.mouseCoordsChores = {
        x: el.getBoundingClientRect().x,
        y: el.getBoundingClientRect().y
      }
    },
    propertiesFilterClicked() {
      this.propertiesFilterSelected = !this.propertiesFilterSelected
      const el = this.$refs['task-cards-property-filter']
      this.mouseCoordsProperties = {
        x: el.getBoundingClientRect().x,
        y: el.getBoundingClientRect().y
      }
    },
    async assignmentCreated() {
      this.showAssignmentMenu = false
      await this.reload()
    },
    async assignmentEdited() {
      this.showEditAssignmentMenu = false
      await this.reload()
    },
    async toggleAssignmentMenu(selChore) {
      if (selChore != null) {
        this.selChore = selChore
        const { data, message } = await calls.GET(
          'chores/property/from',
          selChore.uuid
        )
        this.referencedProperty = data
      }
      this.showAssignmentMenu = !this.showAssignmentMenu
      if (this.showAssignmentMenu == false) {
        this.selChore = null
        this.referencedProperty = null
      }
    },
    async deleteAssignment(assignment) {
      const { message, data } = await calls.DELETE(
        `assignment/${assignment.housemate.uuid}/${assignment.chore.uuid}`
      )
      await this.reload()
    },
    toggleEditAssignment(assignment) {
      this.selAssignment = assignment
      this.showEditAssignmentMenu = assignment ? true : false
    },
    async reload() {
      this.showDeleteMenu = false
      this.showMenu = false
      this.showEditAssignmentMenu = false
      this.chores = []
      this.allHousemates = []
      await this.loadData()
      this.choreListKey += 1
    },
    async editTask(task) {
      this.selTask = task
      this.toggleMenu()
    },
    toggleMenu() {
      this.showMenu = !this.showMenu
      if (!this.showMenu) this.selTask = null
    },
    toggleDeleteMenu() {
      this.showDeleteMenu = !this.showDeleteMenu
      if (!this.showDeleteMenu) this.selTask = null
    },
    async loadData() {
      {
        const { data, message } = await calls.GET('properties')
        this.properties = data
      }
      {
        const { data, message } = await calls.GET(
          'chores/from/a',
          this.$route.params.id
        )

        const promises = []
        for (const chore of data)
          promises.push(calls.GET('chores/property/from', chore.uuid))
        const results = await Promise.all(promises)
        for (const index in results) {
          const property = results[index].data
          if (property == null) continue
          data[index].propertyInternalName = property.internalName
          data[index].propertyUuid = property.uuid
        }
        this.chores = data
      }
      {
        const { data, message } = await calls.GET('housemates')
        this.allHousemates = data
      }
    },
    async signout() {
      try {
        const result = auth.signOut()
      } catch (e) {
        console.error(e.message)
      }
    }
  },

  async beforeMount() {
    await this.signout()
    await this.loadData()
  }
}
</script>

<style scoped>
#propButton {
  width: 120px;
  height: 48px;
  border-radius: 4px;
  border: solid 1px #cbd4dc;
  background-color: #ffffff;
  color: #767675;
  font-size: 14px;
  border: none;
  margin-right: 10px;
}
.chores-body {
  padding-top: 1%;
  padding-bottom: 1%;
  display: flex;
  flex-flow: column nowrap;

  align-items: center;
  overflow: scroll;
  width: 100%;
  height: 100%;
}

.chores-title {
  font-family: Montserrat;
  font-size: 28px;
  font-style: normal;
  font-weight: 900;
  line-height: 40px;
  letter-spacing: 1px;
  text-align: left;
}

.chores-menu-container {
  width: 650px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}

.chores-select-property-dropdown,
.chores-select-chore-dropdown,
.chores-new-assignment-button,
.chores-new-chore-button {
  height: 100%;
}

.chores-new-assignment-button,
.chores-new-chore-button {
  width: 160px;
}

.chores-select-chore-dropdown,
.chores-select-property-dropdown {
  cursor: pointer;
  width: 130px;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: center;
  color: #767675;
  border: 1px solid #cbd4dc;
  border-radius: 4px;
}

.chores-new-assignment-button {
  cursor: pointer;
  background: #f0f8e8;
  border: 1px solid #66b015;
  border-radius: 4px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 850;
  font-size: 14px;
  line-height: 19px;
  color: #66b015;
}

.chores-new-chore-button {
  cursor: pointer;
  background-color: #66b015;
  border: none;
  border-radius: 4px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
}
#chores-new-chore-router-link {
  font-size: 14px;
  color: #ffffff;
  text-decoration: none;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 900;
  letter-spacing: 0px;
}

.cellContainer {
  display: flex;
  justify-content: center;
  align-items: center;
}

.task-cards-filter {
  cursor: pointer;
  background: #ffffff;
  border: 1px solid #cbd4dc;
  box-sizing: border-box;
  border-radius: 4px;
  width: 120px;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  align-items: center;
  color: #767675;
}

.task-cards-filter.selected {
  background: #ffffff;
  border: 1px solid #66b015;
  color: #66b015;
}

.empty-chores-screen {
  width: 100%;
  padding-top: 10%;
  height: 90%;
}
.empty-chores-screen img {
  width: 50%;
  height: 50%;
}

.empty-chores-screen div {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 40px;
}

.empty-chores-screen button {
  border: none;
  background: #66b015;
  border-radius: 4px;
  width: 192px;
  height: 40px;
  color: white;
  font-family: Montserrat;
  font-size: 16px;
}

.no-result {
  font-weight: 900 !important;
}

.task-calendar-filter-container {
  position: absolute;
}
</style>
